import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { AlertService } from '@context/frontend/alert';
import { Organization } from '@context/shared/types/organization';
import { DocumentReference } from 'firebase/firestore';
import { AdminOrganizationService } from '../services';

type OrganizationResolveData = {
	data: Organization;
	ref: DocumentReference<Organization>;
};

@Injectable({ providedIn: 'root' })
export class AdminOrganizationDetailResolver implements Resolve<OrganizationResolveData | null> {
	readonly organizationService = inject(AdminOrganizationService);
	readonly router = inject(Router);
	readonly alert = inject(AlertService);

	async resolve(
		route: ActivatedRouteSnapshot,
	): Promise<OrganizationResolveData | null> {
		const id = route.paramMap.get('id');
		if (!id) return this.redirect();

		const snapshot = await this.organizationService
			.findById(id)
			.catch(() => this.redirect());

		const organization = snapshot.data() as Organization;
		return { ref: snapshot.ref, data: organization };
	}

	readonly redirect = () =>
		this.router.navigate(['/organizations']).then(() => {
			this.alert.open('organization-not-found').subscribe();
			return Promise.reject();
		});
}
